import { useEffect } from 'react'

export default function useScrollReset() {
  useEffect(() => {
    const scrollingContainer = document.getElementsByClassName(
      'PageLayoutContainer'
    )[0]
    if (scrollingContainer) {
      scrollingContainer.scrollTop = 0
    }
  }, [])

  return
}
